import React from "react";
import styles from "../css/profilecard.module.css"; 

const Profile = () => {
  const profiles = [
    {
      image: "images/cm2024_jharkhand.webp",
      name: "Shri Hemant Soren",
      title: "Hon'ble Chief Minister",
      department1: "Jharkhand",
      department2: "",
    },
    {
      image: "images/Sudivya_Sir.webp",
      name: "Shri Sudivya Kumar",
      title: "Hon'ble Minister",
      department1: "Department of Tourism, Arts",
      department2: "Culture, Sports & Youth Affairs",
    },
    {
      image: "images/Manoj_Sir.webp",
      name: "Shri Manoj Kumar",
      title: "Secretary",
      department1: "Department of Tourism, Arts",
      department2: "Culture, Sports & Youth Affairs",
    },
    {
      image: "images/New_director_madam.png",
      name: "Smt Vijaya N. Jadhav",
      title: "Director",
      department1: "Directorate Of Tourism",
    },
    {
      image: "images/MD_Sir.png",
      name: "Shri Prem Ranjan",
      title: "Managing Director",
      department1: "Jharkhand Tourism Development Corporation",
    },
    {
      image: "images/GM_Sir.webp",
      name: "Shri Rajeev Kr. Singh",
      title: "General Manager ",
      department1: "Jharkhand Tourism Development Corporation",
    },
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        {profiles.map((profile, index) => (
          <div key={index} className={styles.card}>
            <img src={profile.image} alt={profile.title} className={styles.image} loading="lazy"/>
            <p className={styles.name}>{profile.name}</p>
            <h3 className={styles.title}>{profile.title}</h3>
            <p className={styles.department}>
              {profile.department1}
              {profile.department2 ? `, ${profile.department2}` : ""}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Profile;
